/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { Fragment } from "react";
import PropTypes from "prop-types";
import iconInfo from "assets/IconInfo.svg?url";
import iconNewRule from "assets/IconNewRule.svg?url";
import Tooltip from "rc-tooltip";

import DeleteAllRulesModal from "../DeleteAllRulesModal";
import ContentPolicy from "./components/ContentPolicy";
import { PrimaryButton } from "../shared/button/PrimaryButton";
import { Box, Spinner } from "@chakra-ui/react";
import NativeAppControlPolicy from "./components/NativeAppControlPolicy";
import { useSelectedClassroomStore } from "stores/v2/selectedClassroomStore";
import { userDisplayText } from "../../utils/userUtils";
import _ from "lodash";
import { GreyedButton } from "../shared/button/GreyedButton";
import { useClassroomPolicyStore } from "stores/v2/classroomPolicyStore";
import { ChakraFAIcon } from "@/components/ui/Icon";

export default class PolicyDrawer extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			open: props.open,
			refreshingRules: false, // set to true when a rule api update fails
			deleteRulesModal: false,
			saving: false,
			existing_policy: undefined,
			networkError: false,
		};

		this.classroomId = useSelectedClassroomStore.getState().id;
	}

	componentDidMount() {
		window.addEventListener("scroll", this.handleScroll);
		document.addEventListener("keydown", this.handleOnEscDown, { capture: true });
	}

	componentWillUnmount() {
		window.removeEventListener("scroll", this.handleScroll);
		document.removeEventListener("keydown", this.handleOnEscDown, { capture: true });
	}

	removeAllowed = (entry) => {
		useClassroomPolicyStore.getState().removeAllowedRule(entry, {
			noFetch: true,
			onApiError: this.removalApiFailure,
		});
	};

	removeBlocked = (entry) => {
		useClassroomPolicyStore.getState().removeBlockedRule(entry, {
			noFetch: true,
			onApiError: this.removalApiFailure,
		});
	};

	handleValidationResponse = (data = {}) => {
		const existing_policy = { ...this.state.existing_policy };
		this.setState({ existing_policy: undefined });
		if (data.error || data.networkError) {
			data["timestamp"] = Date.now(); //  to make the response different each time
			this.props.onOpenCreatePolicy(true, existing_policy, data);
		}
	};

	changeType = (new_type, existing_policy) => {
		this.setState({ existing_policy: { ...existing_policy } });

		if (existing_policy.type === "allowed") {
			const modified_policy = { ...existing_policy, type: new_type };
			useClassroomPolicyStore.getState().modifyAllowedRule(modified_policy, {
				onApiError: this.handleValidationResponse,
				callback: this.handleValidationResponse,
			});
		} else {
			const modified_policy = { ...existing_policy, type: new_type, enabled: new_type !== "off" };
			useClassroomPolicyStore.getState().modifyBlockedRule(modified_policy, {
				onApiError: this.handleValidationResponse,
				callback: this.handleValidationResponse,
			});
		}
	};

	changeAppControlType = (type, appControl) => {
		useClassroomPolicyStore.getState().modifyAppControl(
			{
				classroomStableIdV1: useSelectedClassroomStore.getState().stableIdV1,
				classroomId: useSelectedClassroomStore.getState().id,
				classroomSourceName: useSelectedClassroomStore.getState().sourceId,
				data: {
					...appControl,
					action: type,
				},
			},
			{ callback: this.handleValidationResponse }
		);
	};

	removalApiFailure = (errorResponseJson) => {
		this.setState({ refreshingRules: true });
		useClassroomPolicyStore.getState().fetchPolicyAndPopulateStore({
			onApiSuccess: () => this.setState({ refreshingRules: false }),
		});
	};

	removeAllRules = () => {
		this.setState({
			saving: true,
		});
		useClassroomPolicyStore.getState().removeAllRulesAndAppControls({
			classroomId: this.classroomId,
			classroomStableIdV1: useSelectedClassroomStore.getState().stableIdV1,
			classroomSourceName: useSelectedClassroomStore.getState().sourceId,
			options: {
				callback: () => {
					this.setState({
						deleteRulesModal: false,
						saving: false,
					});
				},
				onApiError: () => {
					this.setState({
						networkError: true,
						saving: false,
					});
				},
			},
		});
	};

	// eslint-disable-next-line camelcase
	UNSAFE_componentWillReceiveProps(nextProps) {
		this.setState({ open: nextProps.open });
	}

	renderTag = (policy) => {
		if (policy.tag) {
			return this.props.signatureDb.lookup(policy.tag);
		}
		return "all apps";
	};

	closeDrawer() {
		this.props.onClose();
		this.setState({
			open: false,
		});
	}

	renderDrawerOverlay() {
		if (this.state.open) {
			return <div className="PolicyDrawer_overlay" onClick={this.state.open ? this.closeDrawer.bind(this) : function () {}}></div>;
		}
		return <div />;
	}

	handleScroll = () => {
		if (window.scrollY > 0) {
			if (!this.state.scrolled) {
				this.setState({
					scrolled: true,
				});
			}
		} else if (this.state.scrolled) {
			this.setState({
				scrolled: false,
			});
		}
	};

	handleOnEscDown = (event) => {
		if (event.keyCode === 27) {
			if (!this.state.deleteRulesModal) {
				this.closeDrawer();
			}
		}
	};

	policyDrawerClassName = () => {
		if (this.state.open) {
			return this.state.scrolled ? "PolicyDrawer--scrolled" : "PolicyDrawer";
		} else {
			return "PolicyDrawer--closed";
		}
	};

	areRulesPresent = () => {
		if (!this.props.policy) {
			return false;
		}

		return (
			(this.props.policy.blocked && this.props.policy.blocked.length) || (this.props.policy.allowed && this.props.policy.allowed.length)
		);
	};

	getActiveRulesCount = () => {
		let rulesCount = 0;

		if (!this.props.policy) {
			return rulesCount;
		}

		if (this.props.policy.blocked) {
			rulesCount += this.props.policy.blocked.length;
		}

		if (this.props.policy.allowed) {
			rulesCount += this.props.policy.allowed.length;
		}

		if (this.props.nativeAppControls) {
			rulesCount += this.props.nativeAppControls.length;
		}

		return rulesCount;
	};

	closeDeleteAll = () => {
		this.setState({
			deleteRulesModal: false,
			saving: false,
			networkError: false,
		});
	};

	renderButtons = () => {
		if (this.state.saving) {
			return <PrimaryButton className="mui-flat-button" label={<Spinner color="white" width={"12px"} height={"12px"} />} />;
		}

		if (this.state.networkError) {
			return <GreyedButton className="mui-flat-button" label="Try again" onClick={this.closeDeleteAll} />;
		}

		return (
			<div>
				<button className="DeleteAllRulesModal_DeleteButton" type="button" onClick={this.removeAllRules}>
					Delete
				</button>
			</div>
		);
	};

	render() {
		const rulesCount = this.getActiveRulesCount();

		return (
			<div className={this.policyDrawerClassName()}>
				{this.renderDrawerOverlay()}
				<DeleteAllRulesModal
					open={this.state.deleteRulesModal}
					onActions={this.renderButtons()}
					onClose={this.closeDeleteAll}
					rulesCount={rulesCount}
					onDelete={this.removeAllRules}
				/>
				{this.state.open ? (
					<div className="PolicyDrawer_container">
						<div className="PolicyDrawer_titleBar">
							<div className="PolicyDrawer_title">
								Rules
								<a
									className="PolicyDrawer_infoIcon"
									href="https://help.classwize.net/hc/en-gb/articles/5573453442972-Introduction-to-Classwize-Rules"
									target="_blank"
									rel="noopener noreferrer"
								>
									<Tooltip
										placement="bottom"
										trigger={["hover"]}
										destroyTooltipOnHide={true}
										overlayClassName="Tooltip"
										overlay={<span>Learn more</span>}
									>
										<img className="PolicyDrawer_info" src={iconInfo} alt="" />
									</Tooltip>
								</a>
							</div>
							{!!rulesCount && (
								<Fragment>
									<div className="PolicyDrawer_deleteAllRuleButton">
										<div
											title="Delete all rules"
											onClick={() =>
												this.setState({
													deleteRulesModal: !this.state.deleteRulesModal,
												})
											}
										>
											<ChakraFAIcon icon="fa-trash" variant="solid" className="PolicyDrawer_addRuleButtonIcon" />
											<span>Delete all</span>
										</div>
									</div>
									<div className="PolicyDrawer_addRuleButton">
										<div title="New Rule" onClick={() => this.props.onOpenCreatePolicy(false, {}, {})}>
											<ChakraFAIcon icon="fa-plus" variant="solid" className="PolicyDrawer_addRuleButtonIcon" />
											<span>New Rule</span>
										</div>
									</div>
								</Fragment>
							)}
						</div>
						<div className="PolicyDrawer_itemsContainer">
							{this.state.refreshingRules ? (
								<div className="inline-loader-with-label">
									<Spinner color="white" width={"12px"} height={"12px"} />
									<span>Failed to update rules, resynchronizing</span>
								</div>
							) : (
								<div className="PolicyDrawer_itemsGrid">{this.renderPolicies()}</div>
							)}
						</div>
					</div>
				) : null}
			</div>
		);
	}

	renderPolicies = () => {
		const signatures = [];
		const websites = [];

		for (const policy of this.props.policy.blocked) {
			if (!_.isEmpty(policy.website)) {
				websites.push({ ...policy, type: "blocked" });
			} else {
				signatures.push({ ...policy, type: "blocked" });
			}
		}
		for (const policy of this.props.policy.allowed) {
			if (!_.isEmpty(policy.website)) {
				websites.push({ ...policy, type: "allowed" });
			} else {
				signatures.push({ ...policy, type: "allowed" });
			}
		}

		const getWebsiteOrTag = (policy) => {
			if (policy.website) return policy.website;
			if (policy.tag) return this.props.signatureDb.find(policy.tag)?.name ?? policy.tag;
			return null;
		};

		signatures.sort((a, b) => {
			const tagA = getWebsiteOrTag(a);
			const tagB = getWebsiteOrTag(b);
			if (!tagA) return -1;
			if (!tagB) return 1;
			return tagA.toString().localeCompare(tagB.toString()) || a.id.localeCompare(b.id);
		});
		websites.sort((a, b) => {
			const tagA = getWebsiteOrTag(a);
			const tagB = getWebsiteOrTag(b);
			if (!tagA) return -1;
			if (!tagB) return 1;
			return tagA.toString().localeCompare(tagB.toString()) || a.id.localeCompare(b.id);
		});
		const nativeAppControlsProcessed = this.props.nativeAppControls.sort((a, b) => a.name.localeCompare(b.name));

		if (!signatures.length && !websites.length && !nativeAppControlsProcessed.length) {
			return (
				<div className="PolicyDrawer_noRulesPlaceholder">
					<Box display="flex" justifyContent="center" alignItems="center">
						<img className="PolicyDrawer_newRuleImage" src={iconNewRule} alt="Create your first rule" />
					</Box>
					<div className="PolicyDrawer_noRulesPlaceholderTitle">Create your first rule</div>
					<div className="PolicyDrawer_noRulesPlaceholderSubtitle">Control what students can access during your class.</div>
					<button
						className="PolicyDrawer_createRuleButton MuiButtonBase-root MuiButton-root MuiButton-text mui-flat-button mui-flat-button blue-text-button"
						type="button"
						onClick={() => this.props.onOpenCreatePolicy(false, {}, {})}
					>
						Create rule
					</button>
					<div>
						<a
							className="PolicyDrawer_introRulesLink"
							href="https://help.classwize.net/hc/en-gb/articles/5573453442972-Introduction-to-Classwize-Rules"
							target="_blank"
							rel="noopener noreferrer"
						>
							Learn more
						</a>
					</div>
				</div>
			);
		}

		return (
			<>
				{signatures.length > 0 ? <div className="PolicyDrawer_sectionHeader">signatures and categories</div> : null}
				{signatures.map((policy) => (
					<ContentPolicy
						className="PolicyDrawer_item"
						signatureDb={this.props.signatureDb}
						handleModify={() => this.props.onOpenCreatePolicy(true, policy, {})}
						handleChangeType={this.changeType}
						policy={policy}
						key={policy.id}
						users={this.props.users}
					/>
				))}
				{websites.length > 0 ? <div className="PolicyDrawer_sectionHeader">websites</div> : null}
				{websites.map((policy) => (
					<ContentPolicy
						className="PolicyDrawer_item"
						signatureDb={this.props.signatureDb}
						handleModify={() => this.props.onOpenCreatePolicy(true, policy, {})}
						handleChangeType={this.changeType}
						policy={policy}
						key={policy.id}
						users={this.props.users}
					/>
				))}
				{nativeAppControlsProcessed.length > 0 ? <div className="PolicyDrawer_sectionHeader">app controls</div> : null}
				{nativeAppControlsProcessed.map((nativeAppControl) => {
					const user = useSelectedClassroomStore
						.getState()
						.students?.find((student) => student.stableIdV1 === nativeAppControl.studentStableIdV1);
					const _userDisplayText = user ? userDisplayText(user) : null;
					return (
						<NativeAppControlPolicy
							className="PolicyDrawer_item"
							isClassroomRule={nativeAppControl.isClassroomRule}
							userDisplayText={_userDisplayText}
							appName={nativeAppControl.name}
							appFavicon={this.props.nativeAppControlsDb.find(nativeAppControl.appControlId).favicon}
							action={nativeAppControl.action}
							handleModify={() => this.props.onOpenCreatePolicy(true, nativeAppControl, {}, "NATIVE_APP_CONTROL")}
							handleChangeAction={(type) => this.changeAppControlType(type, nativeAppControl)}
						/>
					);
				})}
			</>
		);
	};
}

PolicyDrawer.propTypes = {
	signatureDb: PropTypes.object,
	policy: PropTypes.object,
	onOpenCreatePolicy: PropTypes.func,
	onClose: PropTypes.func,
	open: PropTypes.bool,
	users: PropTypes.array,
};
